import React, { useState, useEffect, useContext,  useMemo } from "react";
import FileUploadTable from "components/Content/CustomTable/FileUploadTable";
import TableStyle from "components/Content/Table/TableStyle.module.css";
import TableAllData from "components/Content/CustomTable/TableAllData";
import { Box, Button, IconButton } from "@mui/material";
import ButtonStyle from "components/Button/ButtonStyle.module.css";

import PublishOutlinedIcon from "@mui/icons-material/PublishOutlined";
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import KeyboardArrowUpOutlinedIcon from '@mui/icons-material/KeyboardArrowUpOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';

import { apiGet } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";

import { Utils } from "common/Utils";

import FileUploadsDialog from "components/Content/Modal/FileUploadsDialog";
import AximTooltip from "components/AximTooltip";
import StatusDetailsDialog from "components/Content/Modal/StatusDetailsDialog";

export default function HoursUpload() {
    const { companyId, error } = useContext(PrivateRoutesContext);
    const [isLoading, setIsLoading] = useState(true);
    const [isFileDialogOpen, setIsFileDialogOpen] = useState(false);
    const [userUploads, setUserUploads] = useState([]);

    const [doShowStatusDetails, setDoShowStatusDetails] = useState(false);
    const [statusTitle, setStatusTitle] = useState("");
    const [statuses, setStatuses] = useState([]);

    // FILE UPLOAD START
    useEffect(() => {
      getUserUploads(companyId);
    }, [companyId]);
    
    const getUserUploads = (companyId) => {
        if (!companyId) {
            companyId = localStorage.getItem(`selectedCompanyId`);
        }
        
        setIsLoading(true);

        apiGet(apiUrls.getUserUploads(companyId, "1FC2673C-CECE-43E0-988B-21923E49A190")).then(
            (response) => {
                let hwBenefitDates = Utils.groupByArrays(response.data, 'hwBenefitDate');

                let uu = [];

                for (let index in hwBenefitDates) {
                    let hwBenefitDate = hwBenefitDates[index];

                    let orderedUploads = hwBenefitDate.values.sort((a,b) => (new Date(a.uploadDate) < new Date(b.uploadDate)) ? 1 : -1);

                    var uploadHeader = { 
                      hwBenefitDate: hwBenefitDate.key, 
                      status: orderedUploads[0].status, 
                      uploadDate: orderedUploads[0].uploadDate, 
                      uploadUser: orderedUploads[0].uploadUser,
                      values: orderedUploads,
                    };
                    
                    uu.push(uploadHeader);
                }

                uu = uu.sort((a,b) => new Date(a.hwBenefitDate) < new Date(b.hwBenefitDate) ? 1 : -1);

                setUserUploads(uu);

                setIsLoading(false);
            }
        ).catch(
          (response) => {
            error.setTitle("An Error Occurred");
            error.setText("An Error occurred loading the files.");
            error.setDoShowError(true);
            setIsLoading(false);
          }
        );
    }

    useEffect(() => {
      apiGet(apiUrls.getStatuses("USERUPLOAD"))
        .then((response) => {
          setStatuses(response.data);
      })
      .catch(function (e) {
          setStatuses([]);
      });
    }, []);

  const columns = useMemo(() => [
    {
        id: 'expander',
        Header: "",
        Cell: ({ row }) => {
            return row.isExpanded ?
              <AximTooltip title="Hide Uploads">
                <KeyboardArrowDownOutlinedIcon onClick={() => toggleExpandedRow(row)} />
              </AximTooltip> :
              <AximTooltip title="Show Uploads">
                <KeyboardArrowUpOutlinedIcon onClick={() => toggleExpandedRow(row)} />
              </AximTooltip>
        },
    },
    {
        Header: "HW Benefit Date",
        accessor: (cell) => Utils.formatDate(cell.hwBenefitDate),
        Cell: ({row}) => (
          <Box>
            {Utils.formatDate(row.original.hwBenefitDate, true)}
          </Box>
        ),
        sortType: "dateSort",
    },
    {
        Header: () => {
          return (
            <>
              Status
              <IconButton onClick={showStatuses} className="py-0" color="primary"><ListAltOutlinedIcon /></IconButton>
            </>
          )
        },
        accessor: "status",
    },
    {
        Header: "Upload Date",
        accessor: (cell) => Utils.formatDate(cell.uploadDate),
        Cell: ({row}) => (
          <Box>
            {Utils.formatDate(row.original.uploadDate)}
          </Box>
        ),
        sortType: "dateSort",
    },
    {
        Header: "Upload By",
        accessor: "uploadUser",
    },
  ]);
  
  const showStatuses = e => {
    e.stopPropagation();

    setStatusTitle("Hours Upload Statuses");
    setDoShowStatusDetails(true);
  }

  const toggleExpandedRow = (row, fileId) => {
    row.toggleRowExpanded();
  }

  const renderRowSubComponent = React.useCallback(
      ({ row, rowProps, visibleColumns }) => {
        return (
            <FileUploadTable uploadFiles={row.original.values} isLoading={false} doDisplayErrorToggle={true} />
        );
  });
  
  return (
    <div>
          <div className={TableStyle.tableWrapper}>
            <TableAllData
              columns={columns}
              data={userUploads}
              isLoading={isLoading}
              renderRowSubComponent={renderRowSubComponent}
              headerContents={
                <Button
                  variant="outlined"
                  color="primary"
                  className={ButtonStyle.CsubmitBtn}
                  onClick={() => setIsFileDialogOpen(true)}
                  startIcon={<PublishOutlinedIcon />}
                >
                  Upload File
                </Button>
              }
            />

        {/* FILE UPLOAD MODAL */}
        <FileUploadsDialog openModal={isFileDialogOpen} handleClose={() => setIsFileDialogOpen(false)} getUserUploads={getUserUploads} />

        <StatusDetailsDialog doShow={doShowStatusDetails} handleClose={() => setDoShowStatusDetails(false)} title={statusTitle} statuses={statuses} />
      </div>
    </div>
  );
}